// extracted by mini-css-extract-plugin
module.exports = {"profile_holder":"PeopleBlocksFlat_profile_holder__7SSW2","name":"PeopleBlocksFlat_name__rRStf","position":"PeopleBlocksFlat_position__zPgG_"};